import { render, staticRenderFns } from "./Igv.vue?vue&type=template&id=a4e74c80&"
import script from "./Igv.vue?vue&type=script&lang=js&"
export * from "./Igv.vue?vue&type=script&lang=js&"
import style0 from "./Igv.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports